<template>
  <div id="error-modal">
    <v-dialog
      transition="dialog-top-transition"
      min-width="300px"
      width="auto"
      v-model="showModal"
    >
      <v-card>
        <v-toolbar
          :title="$t('errorModal.title')"
        >
          <v-btn
            icon
            dark
            @click="closeModal"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <div class="text-h6 pa-5"> {{ this.errorMessage }} </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            variant="text"
            @click="closeModal"
          >{{ $t('errorModal.buttons.okButton') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: "ErrorModal",
  data() {
    return {
      showModal: false,
      errorMessage: undefined,
    }
  },
  created() {    
    this.emitter.on("showErrorModal", (errorMessage) => {
      this.errorMessage = this.$t(`errorTypes.${errorMessage}`);
      this.showModal = true;
    })
  },
  methods: {
    closeModal() {
      this.showModal = false;
    }
  }
}
</script>

<style lang="scss" scoped>
#error-modal {
  v-dialog {
    min-width: 300px;
  }
}
</style>